<div class="modal-header border-bottom">
  <h6 class="modal-title fs-5-5">Connect Wallet</h6>
  <div class="close cursor-pointer fs-3" aria-label="Close" (click)="ngbActiveModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </div>
</div>
<div class="modal-body p-3">
  <a class="btn align-items-center d-flex" (click)="connect(wallet.wallet)" *ngFor="let wallet of wallets">
    <img class="wallet-icon me-2" [src]="'/retired-arbitrum/assets/images/icons/' + wallet.icon" />{{ wallet.name }}
  </a>
</div>
